import type { PositionModel } from "../../../model/PositionModel";

export type PositionRateGroup = "daily" | "hourly" | "others";

function getPositionRateGroup(position: PositionModel): PositionRateGroup {
  switch (position.payrateType) {
    case "daily":
      return "daily";
    case "hourly":
      return "hourly";
    default:
      return "others";
  }
}

export function groupPositionsByRateType(positions: PositionModel[]) {
  const groupedPositions: { group: PositionRateGroup; positions: PositionModel[] }[] = [
    { group: "daily", positions: positions.filter((position) => position.payrateType === "daily") },
    {
      group: "hourly",
      positions: positions.filter((position) => position.payrateType === "hourly"),
    },
    {
      group: "others",
      positions: positions.filter((position) => getPositionRateGroup(position) === "others"),
    },
  ];

  return groupedPositions.filter(({ positions }) => positions.length > 0);
}

export function filterPositionsByName(positions: PositionModel[], searchTerm: string) {
  const normalizedSearchTerm = searchTerm.trim().toLowerCase();

  if (!normalizedSearchTerm) return positions;

  return positions.filter((position) =>
    position.displayName.toLowerCase().includes(normalizedSearchTerm),
  );
}
